export default __webpack_public_path__ + "static/media/marc.bdcfd5a2.jpg";